//=============================================================================
//                       <--- Developed By Icon Team ---> 02 february 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import access from "config/access";

// custom pages
import { mpcDetailStyles } from "./styles";
import createNewAdmin from 'apis/createNewAdmin/createNewAdmin';
import role from 'apis/role/role';
import Context from "context/context";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
// material-ui icons
import ArrowBackOutlinedIcon from "@material-ui/icons/ArrowBackOutlined";
import { useTranslation } from 'react-i18next';
// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: 20,
      },
    },
  },
})(TextField);

export default function CreateNewAdminDetail(props) {
  const { state, dispatch } = useContext(Context);
  const { getAllAdminDetail, update } = createNewAdmin();
  const { getRoleList } = role();
  const history = useHistory();
  const location = useLocation();
  const classes = mpcDetailStyles();
  const [mpc, setMpc] = useState({});
  const [data, setData] = useState({});
  const [dataClone, setDataClone] = useState({});
  const [updated, setUpdated] = useState({});
  const [edit, setEdit] = useState(false);
  const {t,i18n}=useTranslation();
  const [roles, setRoles] = useState([]);

  // setting mpc details
  // useEffect(() => {
  //   if (location.state && location.state.mpc) {
  //     setMpc(location.state.mpc);
  //     return;
  //   } else {
  //     history.goBack();
  //   }
  // }, []);

  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "Create New Admin"],
    });
  }, []);

  // handling api calls
  useEffect(() => {
    if (location?.state?.allAdminId) {
      handleGet();
      handleGetRoles();
      return;
    }
    history.goBack();
  }, []);

  
  
  
  
  
  
  //   let rolesdrop
  
  // if (state?.userInfo?.role_id !== 10){
  
  //  rolesdrop =  roleList.filter(item =>item.role_id != 10)
  // }
  // else{
  //   rolesdrop =  roleList.filter(item =>item.role_id = 10)
  
  // }
  

  // authorized members api func
  const handleGet = async () => {
    try {
      let id = location?.state?.allAdminId;
      let res = await getAllAdminDetail(id);
      if (res) {
        setData(res?.data);
        setDataClone(res?.data);
      }
    } catch (e) {
      console.log({ e });
    }
  };

  // authorized members api func
  const handleGetRoles = async () => {
    try {           
      let res = await getRoleList();
      if (res) {
        setRoles(res.data)
      }
    } catch (e) {
      console.log({ e });
    }
  };

  let rolesdrop
  
  if (state?.userInfo?.role_id !== 10){
  
    rolesdrop = roles.filter(item => item.role_id !== 10 && item.role_id !== 13);
  }
  else{
    rolesdrop =  roles
  
  }

  const handleUpdate = async () => {
    try {
      let arg = {};
      arg = { updated, id: data?.user_id };
      let res = await update(arg);
      if (res) {
        setDataClone({ ...dataClone, ...res?.data });
        setEdit(false);
        history.push("/dashboard/upload-success", {
          type: "Data is updated to our system successfully.",
        });
      }
    } catch (e) {
      console.log({ e });
    }
  };

  let editObj = {
    // role_id: { edit: edit, type: "number" },
    role_id: {
      edit: edit,
      type: "select",
      options: [
        { value: 3, label: "Program Admin" },
        { value: 10, label: "IT Admin" },
        { value: 9, label: "Accounting" },
        { value: 12, label: "Observer" },
        { value: 13, label: "Super Admin" },
      ],
    },
    email: {
      edit: edit,
      type: "text"
    },
    first_name: {
      edit: edit,
      type: "text"
    },
    last_name: {
      edit: edit,
      type: "text"
    },
    is_active: {
      edit: edit,
      type: "select",
      options: [
        { value: true, label: "Active" },
        { value: false, label: "Inactive" },

      ],
    },
  };

  let nameObj = {
    email: "Email",
    first_name: "First Name",
    is_active: "Status",
    last_name: "Last Name",
    role_id: "Role",
    
  
  };

  let offset = location?.state?.offset;

  return (
    <React.Fragment>
      <Grid container style={{ padding: 10 }}>
        <Grid item xs={6}>
          <Button
            className={classes.editBtn}
            onClick={() => {
              history.push("/dashboard/create-new-admin", { offset });
            }}
          >
            {t('Back')}
          </Button>
        </Grid>
      </Grid>
      
      <Grid container>
        <div className={classes.firstDiv}>
          <div className={classes.secondDiv}>{t('Admin  Details')}</div>
        </div>
        <Grid xs={12} lg={6} className={classes.grid}>
        
          {editObj["email"]?.edit ? (
            <Grid container>
              <Grid item xs={12}>
                <span style={{ fontWeight: "bold", verticalAlign: "Sub" }}>
                  {nameObj["email"]}&nbsp;:&nbsp;
                </span>
                <CssTextField
                  variant="outlined"
                  type={"email"}
                  fullWidth
                  className={classes.cssTextField}
                  value={data?.["email"]}
                  onChange={(e) => {
                    setData({ ...data, ["email"]: e.target.value });
                    setUpdated({ ...updated, ["email"]: e.target.value });
                  }}
                >
                 
                </CssTextField>
              </Grid>
            </Grid> 
          ) : (
            <div>
            <span className={classes.gridSpan}>{t('Email')} </span> :{" "}
            {data.email}
          </div>
        )}
        </Grid>
        {/* <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Role')}</span> :{" "}
            {data.HS_Role.role_name}
          </div>
        </Grid> */}
        <Grid xs={12} lg={6} className={classes.grid}>
          
          {editObj["first_name"]?.edit ? (
            <Grid container>
              <Grid item xs={12}>
                <span style={{ fontWeight: "bold", verticalAlign: "Sub" }}>
                  {nameObj["first_name"]}&nbsp;:&nbsp;
                </span>
                <CssTextField
                  variant="outlined"
                  type={"text"}
                  fullWidth
                  className={classes.cssTextField}
                  value={data?.["first_name"]}
                  onChange={(e) => {
                    setData({ ...data, ["first_name"]: e.target.value });
                    setUpdated({ ...updated, ["first_name"]: e.target.value });
                  }}
                >
                 
                </CssTextField>
              </Grid>
            </Grid> 
          ) : (
            <div>
            <span className={classes.gridSpan}>{t('First Name')} </span> :{" "}
            {data.first_name}
          </div>
        )}
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          {editObj["last_name"]?.edit ? (
            <Grid container>
              <Grid item xs={12}>
                <span style={{ fontWeight: "bold", verticalAlign: "Sub" }}>
                  {nameObj["last_name"]}&nbsp;:&nbsp;
                </span>
                <CssTextField
                  variant="outlined"
                  type={"text"}
                  fullWidth
                  className={classes.cssTextField}
                  value={data?.["last_name"]}
                  onChange={(e) => {
                    setData({ ...data, ["last_name"]: e.target.value });
                    setUpdated({ ...updated, ["last_name"]: e.target.value });
                  }}
                >
                 
                </CssTextField>
              </Grid>
            </Grid> 
          ) : (
            <div>
            <span className={classes.gridSpan}>{t('Last Name')} </span> :{" "}
            {data.last_name}
          </div>
        )}
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
       
            {editObj["role_id"]?.edit ? (
            <Grid container>
              <Grid item xs={12}>
                <span style={{ fontWeight: "bold", verticalAlign: "Sub" }}>
                  {nameObj["is_active"]}&nbsp;:&nbsp;
                </span>
                <CssTextField
                  variant="outlined"
                  select
                  fullWidth
                  className={classes.cssTextField}
                  value={data?.["is_active"]}
                  onChange={(e) => {
                    setData({ ...data, ["is_active"]: e.target.value });
                    setUpdated({ ...updated, ["is_active"]: e.target.value });
                  }}
                >
                  {editObj["is_active"]?.options.map((r, i) => (
                    <MenuItem value={r.value} key={i}>
                      {t(r.label)}
                    </MenuItem>
                  ))}
                </CssTextField>
              </Grid>
            </Grid> 
          ) : (
            <div>
            <span className={classes.gridSpan}>{t('Status')} </span> :{" "}
            {typeof data?.["is_active"] == "boolean" ? (
              data?.["is_active"] ? (
                <span className={classes.activeSpan}>{t('Active')}</span>
              ) : (
                <span className={classes.inActiveSpan}>{t('Inactive')}</span>
              )
            ) : (
              data["is_active"]
            )}
          </div>
        )}
        </Grid>
      </Grid>

      <Grid container>
        {/* <div className={classes.firstDiv}>
          <div className={classes.secondDiv}>{t('Admin Details')}</div>
        </div> */}
     
        <Grid xs={12} lg={6} className={classes.grid}>
       {editObj["role_id"]?.edit ? (
            <Grid container>
              <Grid item xs={12}>
                <span style={{ fontWeight: "bold", verticalAlign: "Sub" }}>
                  {nameObj["role_id"]}&nbsp;:&nbsp;
                </span>
                <CssTextField
                  variant="outlined"
                  select
                  fullWidth
                  className={classes.cssTextField}
                  value={data?.["role_id"]}
                  onChange={(e) => {
                    setData({ ...data, ["role_id"]: e.target.value });
                    setUpdated({ ...updated, ["role_id"]: e.target.value });
                  }}
                >
                  {rolesdrop.filter(r => r.is_cdr_admin == true).map((r, i) => (
                    <MenuItem value={r.role_id} key={r.role_id}>
                      {t(r.role_name)}
                    </MenuItem>
                  ))}
                </CssTextField>
              </Grid>
            </Grid> 
          ) : (
            <div>
            <span className={classes.gridSpan}>{t('Role')} </span> :{" "}
            {/* {data?.["role_id"]? (
              data?.["role_id"]==10 ? 
              "IT Admin"
              : (data?.["role_id"]==3?
                "Program Admin":(data?.["role_id"]==9?"Accounting":(data?.["role_id"]==13?"Super Admin":"Observer" ))
              )
            ) : (
              data["role_id"]
            )} */}
            { data?.["HS_Role.role_name"]}
          </div>
        )}
        </Grid>
        {/* {state?.userInfo?.loyalty_organization_name=='Henry Schein Canada'&&
        <Grid xs={12} lg={6} className={classes.grid}>
          {editObj["role_id"]?.edit ? (
            <Grid container>
              <Grid item xs={12}>
                <span style={{ fontWeight: "bold", verticalAlign: "Sub" }}>
                  {nameObj["role_id"]}&nbsp;:&nbsp;
                </span>
                <CssTextField
                  variant="outlined"
                  select
                  fullWidth
                  className={classes.cssTextField}
                  value={data?.["role_id"]}
                  onChange={(e) => {
                    setData({ ...data, ["role_id"]: e.target.value });
                    setUpdated({ ...updated, ["role_id"]: e.target.value });
                  }}
                >
                  {editObj["role_id"]?.options.map((r, i) => (
                    <MenuItem value={r.value} key={i}>
                      {t(r.label)}
                    </MenuItem>
                  ))}
                </CssTextField>
              </Grid>
            </Grid>
          ) : (
            <div>
              <span className={classes.gridSpan}>{t('Role Id')} </span> :{" "}
              {typeof data?.["role_id"] == "boolean" ? (
                data?.["role_id"] ? (
                  <span className={classes.activeSpan}>{t('Yes')}</span>
                ) : (
                  <span className={classes.inActiveSpan}>{t('No')}</span>
                )
              ) : (
                data["allow_promotion"]
              )}
            </div>
          )}
        </Grid>} */}
        {/* {state?.userInfo?.loyalty_organization_name=='Henry Schein Canada'&&
        <Grid xs
        ={12} lg={6} className={classes.grid}>
          {editObj["allow_tier"]?.edit ? (
            <Grid container>
              <Grid item xs={12}>
                <span style={{ fontWeight: "bold", verticalAlign: "Sub" }}>
                  {nameObj["allow_tier"]}&nbsp;:&nbsp;
                </span>
                <CssTextField
                  variant="outlined"
                  select
                  fullWidth
                  className={classes.cssTextField}
                  value={data?.["allow_tier"]}
                  onChange={(e) => {
                    setData({ ...data, ["allow_tier"]: e.target.value });
                    setUpdated({ ...updated, ["allow_tier"]: e.target.value });
                  }}
                >
                  {editObj["allow_tier"]?.options.map((r, i) => (
                    <MenuItem value={r.value} key={i}>
                      {t(r.label)}
                    </MenuItem>
                  ))}
                </CssTextField>
              </Grid>
            </Grid>
          ) : (
            <div>
              <span className={classes.gridSpan}>{t('Tier')} </span> :{" "}
              {typeof data?.["allow_tier"] == "boolean" ? (
                data?.["allow_tier"] ? (
                  <span className={classes.activeSpan}>{t('Yes')}</span>
                ) : (
                  <span className={classes.inActiveSpan}>{t('No')}</span>
                )
              ) : (
                data["allow_tier"]
              )}
            </div>
          )}
        </Grid>} */}
{/*        
        <Grid xs={12} lg={4} className={classes.grid}>
          {editObj["role_id"]?.edit ? (
            <Grid container>
              <Grid item xs={12}>
                <span style={{ fontWeight: "bold", verticalAlign: "Sub" }}>
                  {nameObj["role_id"]}&nbsp;:&nbsp;
                </span>
                <CssTextField
                  fullWidth
                  variant="outlined"
                  type={editObj["role_id"]?.type}
                  className={classes.cssTextField}
                  disabled={!edit}
                  value={data?.["role_id"]}
                  onChange={(e) => {
                    if (editObj["role_id"]?.type === "text") {
                      setData({
                        ...data,
                        ["role_id"]: e.target.value,
                      });
                      setUpdated({
                        ...updated,
                        ["role_id"]: e.target.value,
                      });
                    }
                    if (editObj["role_id"]?.type === "number") {
                      setData({
                        ...data,
                        ["role_id"]: parseInt(e.target.value),
                      });
                      setUpdated({
                        ...updated,
                        ["role_id"]: parseInt(e.target.value),
                      });
                    }
                  }}
                />
              </Grid>
            </Grid>
          ) : (
            <div>
              <span className={classes.gridSpan}>{t('Role Id')} </span> :{" "}
              {data.role_id}
            </div>
          )}
        </Grid> */}
        <Grid item xs={12} lg={2} className={classes.gridBtn}>
          <Grid item xs={12} lg={6}>
            {edit && (
              <Button
                className={classes.editCancelBtn}
                onClick={() => {
                  setData(dataClone);
                  setEdit(false);
                }}
              >
                {t('cancel')}
              </Button>
            )}
          </Grid>
          <Grid item xs={12} lg={6}>
            <Button
              className={classes.editBtn}
              onClick={()=>{
                if(state?.userInfo?.editAction){
                if (edit) {
                  if (Object.keys(updated).length > 0) {
                    handleUpdate();
                    return;
                  }
                  toast.error("Edit atleast one field.", {
                    toastId: "update-btn",
                  });
                } else {
                  setEdit(true);
                }
                return;
              }
            else{
              toast.error(state.userInfo?.editAccess)
            return;
          }}}
              // disabled={!access['editAccess'][state.userInfo?.role]['mpcdetail']}
            >
              {edit ? "Update" : "Edit"}
            </Button>
          </Grid>
        </Grid>
        {/* <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Org name')}</span> :{" "}
            {t(data.loyalty_organization_name)}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>{t('Site name')}</span> :{" "}
            {t(data.loyalty_site_id)}
          </div>
        </Grid> */}
      </Grid>
    </React.Fragment>
  );
}
